import React from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import GameStep from './GameStep';
import ButtonNext from './ButtonNext';
import RuleOfConduct from './RuleOfConduct';

const GameFlow = ({hasNextButton = false}) => (
    <Page title={'Spelverloop'}>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: '1080px',
        }}>
            <div style={styles.title}>Spelverloop</div>
            <div className={'bodyContainer'} style={{flexDirection: 'column'}}>
                <div style={styles.row}>
                    <GameStep step={1}/>
                    <GameStep step={2}/>
                    <GameStep step={3}/>
                    <GameStep step={4}/>
                    <GameStep step={5} hasNextStep={false}/>
                </div>

                <div style={styles.row}>
                    <GameStep step={6}/>
                    <GameStep step={7}/>
                    <GameStep step={8}/>
                    <GameStep step={9}/>
                    <GameStep step={10} hasNextStep={false}/>
                </div>

                <div style={{position: 'relative'}}>
                    {hasNextButton && <div style={styles.nextContainer}>
                        <ButtonNext navigateDeviceNext={false}/>
                    </div>}
                </div>
            </div>
        </div>
    </Page>
);

RuleOfConduct.propTypes = {
    hasNextButton: PropTypes.bool,
}

const styles = {
    row: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: '50px',
    },
    nextContainer: {
        position: 'absolute',
        bottom: -100,
        right: 50,
    },
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '48px',
        fontStyle: 'italic',
        lineHeight: '48px',
        paddingBottom: '25px',
        marginBottom: '25px',
        width: '100%',
    },
}

export default GameFlow;
